<template>
  <div class="auth-modal">
    <auth-info-modal ref="infoModal" @next="showProjectModal"></auth-info-modal>
    <auth-project-modal
      ref="projectModal"
      @submit="submit"
    ></auth-project-modal>
  </div>
</template>

<script>
import AuthInfoModal from '@/components/AuthInfoModal';
import AuthProjectModal from '@/components/AuthProjectModal';
import ApiService from '@/common/api.service';
export default {
  components: {
    AuthInfoModal,
    AuthProjectModal
  },
  methods: {
    show() {
      this.$refs.infoModal.show();
    },
    showProjectModal() {
      this.$refs.projectModal.show();
    },
    submit() {
      let info = this.$refs.infoModal;
      let project = this.$refs.projectModal;
      let param = new FormData();
      param.append('companyName', info.companyName);
      param.append('goodField', info.goodField);
      param.append('provinceName', info.provinceName.province);
      param.append('cityName', info.cityName);
      param.append('companyIntroduce', info.companyIntroduce);
      param.append('logoFile', info.logoFile);
      param.append('businessLicenseFile', info.licenceFile);

      param.append('experienceName', project.experienceName);
      param.append('experienceIntroduce', project.experienceIntroduce);
      param.append('experienceTime', project.experienceTime);

      ApiService.post('/supplierInterface/dosaveSupplier.htm', param, {
        'Content-Type': 'multipart/form-data'
      })
        .then(() => {
          this.$refs.projectModal.hide();
        })
        .catch(() => {
          this.$refs.projectModal.hide();
        });
    }
  }
};
</script>
